import { useEffect, useRef, useState } from 'react';

const DEFAULT_VIEWPORT_WIDTH = 640;
const MIN_VIEWPORT_WIDTH = 320;

export const useObservedWidth = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(DEFAULT_VIEWPORT_WIDTH);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const update = () => {
      setWidth(Math.max(node.clientWidth, MIN_VIEWPORT_WIDTH));
    };

    update();

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      setWidth(Math.max(entry.contentRect.width, MIN_VIEWPORT_WIDTH));
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  return { ref, width };
};